import { API } from "@/lib/api";

export const CHANNELS = ["prod", "stage", "dev"];
export const CHANNEL_LABEL = { prod: "Prod", stage: "Stage", dev: "Dev", other: "Other" };
export const CHANNEL_COLOR = { prod: "#7C3AED", stage: "#22D3EE", dev: "#A1A1AA", other: "#52525B" };

export const usd = (v, digits = 2) => {
    const n = Number(v || 0);
    if (n !== 0 && Math.abs(n) < 0.01) return `$${n.toFixed(4)}`;
    return `$${n.toLocaleString(undefined, { minimumFractionDigits: digits, maximumFractionDigits: digits })}`;
};

export const num = (v) => Number(v || 0).toLocaleString();

export const compact = (v) => {
    const n = Number(v || 0);
    if (n >= 1e9) return `${(n / 1e9).toFixed(2)}B`;
    if (n >= 1e6) return `${(n / 1e6).toFixed(2)}M`;
    if (n >= 1e3) return `${(n / 1e3).toFixed(1)}k`;
    return String(n);
};

export function ago(iso) {
    if (!iso) return "never";
    const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
    if (s < 60) return "just now";
    if (s < 3600) return `${Math.round(s / 60)} min ago`;
    if (s < 86400) return `${Math.round(s / 3600)} h ago`;
    return `${Math.round(s / 86400)} d ago`;
}

export const STATUS_STYLE = {
    reporting: { dot: "bg-emerald-400", text: "text-emerald-300", label: "Reporting" },
    stale: { dot: "bg-amber-400", text: "text-amber-300", label: "Stale" },
    not_reporting: { dot: "bg-red-400", text: "text-red-300", label: "Not reporting" },
};

const pad = (n) => String(n).padStart(2, "0");
const iso = (d) => `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())}`;

export function rangePreset(key) {
    const now = new Date();
    const y = now.getUTCFullYear();
    const m = now.getUTCMonth();
    if (key === "last_month") return { from: iso(new Date(Date.UTC(y, m - 1, 1))), to: iso(new Date(Date.UTC(y, m, 0))) };
    if (key === "30d") return lastDays(30);
    if (key === "year") return { from: `${y}-01-01`, to: iso(now) };
    return { from: iso(new Date(Date.UTC(y, m, 1))), to: iso(now) };
}

export function lastDays(n) {
    const now = new Date();
    return { from: iso(new Date(now.getTime() - (n - 1) * 86400000)), to: iso(now) };
}

export function selectionParams({ scope, channel, server, dateFrom, dateTo, clientId }, extra = {}) {
    const p = new URLSearchParams();
    p.set("scope", scope);
    if (scope === "channel" && channel) p.set("channel", channel);
    if (scope === "server" && server) p.set("server", server);
    if (dateFrom) p.set("date_from", dateFrom);
    if (dateTo) p.set("date_to", dateTo);
    if (clientId) p.set("client_id", clientId);
    Object.entries(extra).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== "") p.set(k, String(v)); });
    return p;
}

export async function downloadCsv(path, params, filename) {
    const token = localStorage.getItem("tf_token");
    const r = await fetch(`${API}${path}?${params.toString()}`, { headers: { Authorization: `Bearer ${token}` } });
    if (!r.ok) throw new Error(`Export failed (HTTP ${r.status})`);
    const url = URL.createObjectURL(await r.blob());
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
}
